export default "__VITE_ASSET__03f1a4b8__"